import React from 'react';
import { Route } from 'react-router-dom';
import { lazyWithRetry } from '@/routes/utils';
import { PRIVACY_POLICY_PATH } from './constants';

const PrivacyPolicy = lazyWithRetry(() => import('@/pages/privacy/PrivacyPolicy'));

export const privacyRoutes = (
  <Route path={PRIVACY_POLICY_PATH} element={<PrivacyPolicy />} />
);
